import { render } from "./EventDetails.vue?vue&type=template&id=9d8a15a2&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9d8a15a2"

export default script